import { IPreloadedState } from 'shared/types/redux';

export const selectOffersData = (state: IPreloadedState) => state.offers.data;
